import { adminActionButtonSx } from 'src/theme/adminActionButton';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Stack, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { resetPassword } from 'src/helper/backend_helper';
import { useNavigate } from 'react-router';

export default function StepResetPassword({ email, otp, authMode }) {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object({
      password: Yup.string().min(6).required('Password is required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required')
    }),
    onSubmit: async (values) => {
      try {
        await resetPassword(
          { password: values.password, email, otp },
          {},
          authMode
        );

        // TODO: call reset password API
        // toast.success('Password updated successfully');
        // Optionally redirect to login
        navigate('/login');
      } catch (err) {
        toast.error('Failed to reset password');
      }
    }
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2}>
        <Typography variant="h6">Reset Your Password</Typography>
        <TextField
          label="New Password"
          type="password"
          name="password"
          fullWidth
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
        <TextField
          label="Confirm Password"
          type="password"
          name="confirmPassword"
          fullWidth
          value={formik.values.confirmPassword}
          onChange={formik.handleChange}
          error={
            formik.touched.confirmPassword &&
            Boolean(formik.errors.confirmPassword)
          }
          helperText={
            formik.touched.confirmPassword && formik.errors.confirmPassword
          }
        />
        {/* <Button type="submit" variant="contained" color="primary">
          Reset Password
        </Button> */}

        <LoadingButton
          fullWidth
          size="medium"
          type="submit"
          variant="contained"
          //   onClick={() => handleLogin}
          loading={formik.isSubmitting}
          sx={{
            ...adminActionButtonSx
          }}
        >
          Reset Password
        </LoadingButton>
      </Stack>
    </form>
  );
}
